import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { resetAutoPopupCounter } from "@/components/FirstTimeHint";

const RouteScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    resetAutoPopupCounter();

    // If URL has a hash, scroll to that element instead of jumping to top.
    if (hash) {
      const id = hash.slice(1);
      // Defer until the target is in the DOM (sections may render after mount).
      const tryScroll = (attempt = 0) => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else if (attempt < 10) {
          setTimeout(() => tryScroll(attempt + 1), 100);
        }
      };
      tryScroll();
      return;
    }

    window.scrollTo({ top: 0, left: 0 });
  }, [pathname, hash]);

  return null;
};

export default RouteScrollToTop;
